module.exports = __webpack_public_path__ + "static/media/gallery-lg-3.782a019f.jpg";